export const widgetCardHeight = 400;
export const widgetCardPaddingVertical = 12;
